// View Component form create by 

// Ernesto Caballero ATCP Techarch - CAM

// September 30 2025

import React from 'react';
import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Table, TableBody, TableRow, TableCell, Button, Card, CardContent, Grid, Typography, Box } from '@material-ui/core';
import { AcceptButton, DeclineButton } from '../../common/CommonComponents/Buttons';
import { BoldTableCell } from '../FuiStyles';
import theme from '../../../theme/theme';

export default function View({
  title,
  width,
  height,
  xdata,
  xlabel,
  closeClick,
  submitfunction,
  skipConfirmation = false
}) {
  const [showView, setShowView] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const elemTitle = title ? title : '';

  return (
    <>
      {/* Review Details Dialog - Exact copy of CommonDialog structure */}
      <Dialog
        open={showView && !confirm}
        onClose={closeClick}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle
          style={{
            backgroundColor: theme.palette.fui.main,
            color: "white",
            height: '2rem',
            padding: '5px 15px',
          }}
        >
          {elemTitle}
        </DialogTitle>
        <DialogContent style={{ overflowY: "unset"}}>
          <DialogContentText style={{ color: "black", fontWeight: "500" }}>
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <Card style={{ height: "100%" }}>
                  <CardContent>
                    <p style={{ fontWeight: "400" }}>
                      Before you submit your request, please take a moment to review the order details below.
                      Ensuring accuracy now will help prevent any issues later on.
                    </p>
                    <Table>
                      <TableBody>
                        {Object.keys(xdata).length > 0 &&
                          Object.entries(xdata).map(([label, value], index) => {
                            let val = value;

                            if(typeof(val) === 'object')
                              val = val.join(', ');

                            return (
                              <TableRow key={index}>
                                <BoldTableCell>{xlabel[index]}</BoldTableCell>
                                <TableCell>{val}</TableCell>
                              </TableRow>
                            );
                          })
                        }
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={5} justifyContent="center" alignItems="center">
                <Card style={{ backgroundColor: "#7500C0", color: "white", height: "100%", padding: 2, display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                  <CardContent style={{ textAlign: "center" }}>
                    <Typography variant="h6" style={{ marginTop: "50px", marginBottom: "50px" }}>
                      Dedicated Virtual Network Setup
                    </Typography>
                    <Box
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        borderRadius: "50%",
                        width: 200,
                        height: 200,
                        margin: "auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography variant="h5">Enterprise</Typography>
                      <Typography variant="body2">Network Solution</Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            {/* Acknowledgment Section */}
            <div style={{ marginTop: '20px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
              <p style={{ fontWeight: "400", margin: '0 0 12px 0' }}>
                By submitting this request, I acknowledge the associated costs, confirm that an approved business justification exists, and verify that all required information and supporting documentation have been provided to support this request.
              </p>
              {/* <p style={{ fontWeight: "600", margin: '0' }}>
                Are you sure you want to proceed with this order?
              </p> */}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'flex-end', padding: '16px 24px' }}>
          <DeclineButton
            onClick={closeClick}
            label="Cancel"
            style={{ marginRight: '8px' }}
          />
          <AcceptButton
            onClick={() => {
              if (skipConfirmation) {
                // Skip confirmation and call submit directly
                submitfunction();
                setShowView(false);
              } else {
                // Show confirmation dialog
                setConfirm(true);
              }
            }}
            label={skipConfirmation ? "Proceed" : "Submit"}
          />
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirm}
        onClose={() => setConfirm(false)}
        fullWidth={false}
      >
        <DialogTitle
          style={{
            backgroundColor: theme.palette.fui.main,
            color: "white",
            height: '2rem',
            padding: '5px 15px',
          }}
        >
          Warning
        </DialogTitle>
        <DialogContent style={{ overflowY: "unset"}}>
          <DialogContentText style={{ color: "black", fontWeight: "500" }}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <strong style={{ fontWeight: '500', fontSize: '1rem' }}>
                Are you sure to proceed with this order?
              </strong>
              <br /><br />
              By clicking the <strong style={{ fontWeight: '500', color: '#c20000' }}>Yes</strong> button,
              you acknowledge that you have read, understood, and agree to be bound by the{' '}
              <a
                href='https://mywizard-aiops.accenture.com/accenture-splunk-msp-license-usage-policy/'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none', color: theme.palette.fui.main }}
              >
                terms and conditions
              </a> of our application.
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <AcceptButton
            onClick={() => {
              submitfunction();
              setShowView(false);
              setConfirm(false);
            }}
            label="Yes"
          />
          <DeclineButton
            onClick={() => setConfirm(false)}
            label="No"
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
